import React from 'react';

import { Button, Space } from 'antd';
import classNames from 'classnames';
import { useDispatch } from 'dva';

import DownloadFileOutlinedIcon from '@/assets/icons/download_file_outlined.svg';
import EyeFilledIcon from '@/assets/icons/eye_filled.svg';
import { CoreEnums } from '@/utils/domain/constants';
import EmbedSVG from '../EmbedSVGIcon';
import styles from './styles.less';

const TableColAttachment = ({ item, editGridMode }) => {
  const dispatch = useDispatch();

  const downloadUrl = item.isBase64
    ? `data:${item.contentType};base64,${item.downloadUrl}`
    : item.downloadUrl;

  const type = _.camelCase(
    CoreEnums.AttachmentFileTypeClassificationStatus[item?.fileTypeClassification ?? 0],
  );

  const handleDownload = () => {
    dispatch({
      type: 'global/directDownload',
      payload: { ...item, downloadUrl },
    });
  };

  const handlePreview = () => {
    dispatch({
      type: 'global/filePreview',
      payload: {
        isBase64: item.isBase64,
        fileType: item.contentType,
        filePath: item.previewUrl ?? downloadUrl,
        filename: item.fileName,
      },
    });
  };

  const renderButtons = (item) => {
    const viewIdName = `rc-view-${item.id || item.fileName}`;
    const downIdName = `rc-download-${item.id || item.fileName}`;
    return (
      <>
        <Button
          type="primary"
          size="small"
          icon={<EmbedSVG id={`${viewIdName}_detail`} src={EyeFilledIcon} />}
          onClick={handlePreview}
        />
        <Button
          type="primary"
          size="small"
          icon={<EmbedSVG id={`${downIdName}_download`} src={DownloadFileOutlinedIcon} />}
          onClick={handleDownload}
        />
      </>
    );
  };

  return (
    <div className={styles.attachPreview}>
      <Space className={styles.fileName} size={13}>
        <div className={classNames(styles.icon, styles[type])} />
        <span>{item.fileName}</span>
      </Space>
      {!editGridMode && (
        <div className={styles.container}>
          <Space size={6}>{renderButtons(item)}</Space>
        </div>
      )}
    </div>
  );
};

export default TableColAttachment;
